var render, staticRenderFns
import script from "./coupon1N.vue?vue&type=script&lang=js"
export * from "./coupon1N.vue?vue&type=script&lang=js"
import style0 from "./coupon1N.vue?vue&type=style&index=0&id=5c6af596&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6af596",
  null
  
)

export default component.exports